// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__wideContainer___Xbqap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: var(--footer-height);
    padding: 0 var(--container-padding-horizontal);
    box-sizing: border-box;
    background-color: var(--black);
}

.styles__container___OVuOD {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: var(--mobile-page-width);
    margin: 0 auto;
}

.styles__currentYear___t34Eb,
.styles__author___pQt_8 {
    color: var(--white);
    font-size: 14px;
}

@media screen and (min-width: 768px) {
    .styles__container___OVuOD {
        max-width: var(--tablets-page-width);
    }
}

@media screen and (min-width: 1024px) {
    .styles__container___OVuOD {
        max-width: var(--desktop-page-width);
    }
}
`, "",{"version":3,"sources":["webpack://./../../shared/components/Footer/styles.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,4BAA4B;IAC5B,8CAA8C;IAC9C,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI;QACI,oCAAoC;IACxC;AACJ;;AAEA;IACI;QACI,oCAAoC;IACxC;AACJ","sourcesContent":["@import \"../../styles/variables.css\";\n\n.wideContainer {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--footer-height);\n    padding: 0 var(--container-padding-horizontal);\n    box-sizing: border-box;\n    background-color: var(--black);\n}\n\n.container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    max-width: var(--mobile-page-width);\n    margin: 0 auto;\n}\n\n.currentYear,\n.author {\n    color: var(--white);\n    font-size: 14px;\n}\n\n@media screen and (min-width: 768px) {\n    .container {\n        max-width: var(--tablets-page-width);\n    }\n}\n\n@media screen and (min-width: 1024px) {\n    .container {\n        max-width: var(--desktop-page-width);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wideContainer": `styles__wideContainer___Xbqap`,
	"container": `styles__container___OVuOD`,
	"currentYear": `styles__currentYear___t34Eb`,
	"author": `styles__author___pQt_8`
};
export default ___CSS_LOADER_EXPORT___;
